import { useEffect, useRef, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import EnergoTooltip from "../../shared/EnergoTooltip";
import Validator from "../../../services/Validator";
import Api from "../../../services/ApiService";
import CountryCodePhoneSelect from "../../shared/CountryCodePhoneSelect";
import UploadStage from "./UploadStage";

const FormStage = ({ setStage, data, setData, setApiError }) => {

    const API = new Api();
    const VALIDATOR = new Validator();
    const [errors, setErrors] = useState({});
    const params = new URLSearchParams(window.location.search);
    const utmCampaign = params.get("utm_campaign");
    const bottomRef = useRef(null);


    useEffect(() => {
        if (utmCampaign !== null) {
            setData(prev => ({ ...prev, x_salespartner_campaign_code: utmCampaign }));
        }
    }, [utmCampaign])

    useEffect(() => {
        if (data.situation !== "") {
            bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [data.situation])

    const btnHandler = () => {
        var tempErrs = {}; 

        if (data.company_type === "") tempErrs.company_type = true;
        if (data.x_is_house_management !== true && data.companyKw !== true && data.case === null) tempErrs.case = true;
        if (data.companyKw && data.contactPerson === "") tempErrs.contactPerson = true;
        if (data.name === "") tempErrs.name = true;
        if (data.company_type === "person" && data.lastName === "") tempErrs.lastName = true;
        if (!VALIDATOR.EmailValid(data.email)) tempErrs.email = "Ungültige E-Mail-Adresse";
        if (data.phone_country === "") tempErrs.phone_country = true;
        if (data.vorwahl === "" || !VALIDATOR.IsNumeric(data.vorwahl)) tempErrs.vorwahl = true;
        if (!VALIDATOR.IsNumeric(data.phone) || data.phone === "") tempErrs.phone = true;
        if (data.case === 6 && data.situation === "") tempErrs.situation = true;

        if (Object.keys(tempErrs).length > 0) {
            return setErrors(tempErrs);
        }


        if (data.company_type === "company" && data.companyKw === true) {
            createTicket();
            setStage("loading");
        }
        else if (data.company_type === "company" && data.companyKw === false && data.case !== 6) {
            registerUser();
        } 
        else if ((data.company_type === 'person' && data.case === 6) || (data.company_type === 'company' && data.case === 6)) {
            setStage('upload');
        }
        else if (data.company_type === "person" && data.case === 5) {
            registerUser()
        }
        else {
            return;
        }
    }

    const createTicket = () => {
        setStage("loading");
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.register_bigcompany_contact(dataForSending)
            .then(() => {setStage("ticket_done")})
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
            });
    }

    const registerUser = () => {
        setStage("loading");
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.register_basic(dataForSending)
            .then(() => {setStage("reg_done")})
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
            })
    }

    return (
        <div>
            <Row className="mt-3">
                <fieldset>
                    <Form.Group as={Row}>
                        <Form.Text className="text-dark" as="legend" sm="12" xl="3">
                            <b>Ich bin...</b>
                        </Form.Text>
                        <Col>
                            <Form.Check
                                name="company_typeId"
                                type="radio"
                                label="Privatperson"
                                checked={data.company_type === "person"}
                                onChange={() => setData(prev => ({ ...prev, company_type: "person", x_is_house_management: false, companyKw: false }))}
                                isInvalid={errors.company_type}
                            />
                            <Form.Check
                                name="company_typeId"
                                type="radio"
                                label="Gewerbebetrieb"
                                checked={data.company_type === "company" && data.x_is_house_management === false}
                                onChange={() => setData(prev => ({ ...prev, company_type: "company", x_is_house_management: false, companyKw: false }))}
                                isInvalid={errors.company_type}
                            />
                            <Form.Check
                                name="company_typeId"
                                type="radio"
                                label="Hausverwaltung"
                                checked={data.x_is_house_management === true && data.company_type === "company"}
                                onChange={() => setData(prev => ({ ...prev, company_type: "company", x_is_house_management: true, companyKw: true }))}
                                isInvalid={errors.company_type}
                            />
                        </Col>
                    </Form.Group>
                </fieldset>
            </Row>
            {data.x_is_house_management === false && data.company_type === "company" &&
                <Row className="mt-3">
                    <fieldset>
                        <Form.Group as={Row}>
                            <Form.Text>
                                <b>Ich verbrauche pro Jahr mehr als 100.000 kWh Strom und/oder 400.000 kWh Gas</b>
                            </Form.Text>
                            <Col>
                                <Form.Check
                                    name="companyKw"
                                    type="radio"
                                    label="Ja"
                                    checked={data.companyKw === true}
                                    value={true}
                                    onChange={e => setData(prev => ({...prev, companyKw: true}))}
                                    isInvalid={errors.companyKw}
                                />
                                <Form.Check
                                    name="companyKw"
                                    type="radio"
                                    label="Nein"
                                    checked={data.companyKw === false}
                                    value={false}
                                    onChange={e => setData(prev => ({...prev, companyKw: false}))}
                                    isInvalid={errors.companyKw}
                                />
                            </Col>
                        </Form.Group>
                    </fieldset>
                </Row>
            }
            <Row className="mt-3">
                <Col>
                    {
                        data.companyKw === false ?
                            <fieldset hidden={data.company_type === ""}>
                                <Form.Group as={Row}>
                                    <Form.Text as="legend">
                                        <div style={{display: "flex", alignItems: "center"}}>
                                            <b>Ich will...</b>
                                        </div>
                                    </Form.Text>
                                    <Col>
                                        <Form.Check
                                            name="caseId"
                                            type="radio"
                                            label={<div style={{display: "flex", alignItems: "center"}}><span style={{marginRight: 10}}>Strom/Gas-Vertrag wechseln / Angebot einholen</span> <EnergoTooltip text={"Es besteht ein laufender Energieliefervertrag auf meinen Namen."} color={"text-warning"} style={{ lineHeight: "1", marginTop: "-2px" }}/></div>}
                                            checked={data.case === 6}
                                            value={6}
                                            onChange={e => setData(prev => ({ ...prev, case: 6 }))}
                                            isInvalid={errors.case}
                                        />
                                        <Form.Check
                                            name="caseId"
                                            type="radio"
                                            label={<div style={{display: "flex", alignItems: "center"}}><span style={{marginRight: 10}}>Strom/Gas neu anmelden</span> <EnergoTooltip text={"Derzeit besteht kein laufender Energieliefervertrag auf meinen Namen. (z.B. Umzug)"} color={"text-warning"} style={{ lineHeight: "1", marginTop: "-2px" }}/></div>}
                                            checked={data.case === 5}
                                            value={5}
                                            onChange={e => setData(prev => ({...prev, case: 5}))}
                                            isInvalid={errors.case}
                                        />
                                    </Col>
                                </Form.Group>
                                <div hidden={!(data.case === 5 || data.case === 6)}>
                                    <p style={{ marginTop:"1rem" }} className="text-dark">
                                        {data.case === 5 ?
                                            `Derzeit besteht kein laufender Energieliefervertrag auf meinen Namen. z.B. Umzug oder Neuanmeldung`
                                        :   
                                            `Es besteht ein laufender Energieliefervertrag auf meinen Namen. Ich möchte ein unverbindliches Angebot einholen und mehr Informationen zur Dienstleistung von ENERGO.`
                                        }
                                    </p>
                                </div> 
                            </fieldset> :

                            <div hidden={data.company_type === ""}>
                                <h5>Kontaktaufnahme</h5>
                                <p style={{ fontSize: 14, fontWeight: 800 }} className="text-dark">
                                    {data.x_is_house_management === true?
                                        `Für Hausverwaltungen bieten wir individuelle Vertragslösungen und Dienstleistungen an. 
                                        Dafür möchten wir gerne mehr zu Ihrer Situation erfahren. Bitte 
                                        hinterlassen Sie Ihre Kontaktdaten. Wir nehmen in Kürze persönlich 
                                        Kontakt mit Ihnen auf!`
                                    :
                                        `Für Abnehmer/innen mit Großanlagen bzw. einer Vielzahl von Anlagen 
                                        bieten wir individuelle Vertragslösungen. Dafür möchten wir gerne 
                                        mehr zu Ihrer Situation erfahren. Bitte hinterlassen Sie Ihre 
                                        Kontaktdaten. Wir nehmen in Kürze persönlich Kontakt mit Ihnen auf!`
                                    }
                                </p>
                            </div>
                    }
                </Col>
            </Row>
            <Row className="mt-3 text-dark">
                <Col>
                    <FloatingLabel label={data.company_type === "company" ? "Unternehmensbezeichnung": "Vorname"}>
                        <Form.Control
                            type="text"
                            placeholder={data.company_type === "company" ? "Unternehmensbezeichnung": "Vorname"}
                            value={data.name}
                            onChange={e => {setErrors({}); setData(prev => ({...prev, name: e.target.value}))}}
                            isValid={data.name !== ""}
                            isInvalid={errors.name}
                        />
                    </FloatingLabel>
                </Col>
                <Col hidden={data.company_type === "company"}>
                    <FloatingLabel label="Nachname">
                        <Form.Control
                            type="text"
                            placeholder="Nachname"
                            value={data.lastName}
                            onChange={e => {setErrors({}); setData(prev => ({...prev, lastName: e.target.value}))}}
                            isValid={data.lastName !== ""}
                            isInvalid={errors.lastName}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {data.companyKw &&
                <Row className="mt-3 text-dark">
                    <Col>
                        <FloatingLabel label="Kontaktperson">
                            <Form.Control
                                type="text"
                                placeholder="Kontaktperson"
                                value={data.contactPerson}
                                onChange={e => {setErrors({}); setData(prev => ({...prev, contactPerson: e.target.value}))}}
                                isValid={data.contactPerson !== ""}
                                isInvalid={errors.contactPerson}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
            }
            <Row className="mt-3 text-dark">
                <Col>
                    <FloatingLabel label="E-Mail">
                        <Form.Control
                            type="email"
                            placeholder="E-Mail"
                            value={data.email}
                            onChange={e => {setErrors({}); setData(prev => ({...prev, email: e.target.value}))}}
                            isValid={VALIDATOR.EmailValid(data.email)}
                            isInvalid={errors.email}
                        />
                    </FloatingLabel>
                    <Form.Text className="text-danger" hidden={errors.email === undefined}>
                        {errors.email}
                    </Form.Text>
                </Col>
            </Row>
            <Row className="mt-3 text-dark">
                <Col>
                    <Form.Group>
                        <CountryCodePhoneSelect data={data} setData={setData} />
                    </Form.Group>
                </Col>
                <Col>
                    <FloatingLabel label="Vorwahl">
                        <Form.Control
                            type="phone"
                            placeholder="Vorwahl"
                            value={data.vorwahl}
                            onChange={e => {setErrors({}); setData(prev => ({...prev, vorwahl: e.target.value}))}}
                            isValid={data.vorwahl !== "" && VALIDATOR.IsNumeric(data.vorwahl)}
                            isInvalid={errors.vorwahl}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3 text-dark">
                <Col>
                    <FloatingLabel label="Telefonnummer">
                        <Form.Control
                            type="phone"
                            placeholder="Telefonnummer"
                            value={data.phone}
                            onChange={e => {setErrors({}); setData(prev => ({...prev, phone: e.target.value}))}}
                            isValid={data.phone !== "" && VALIDATOR.IsNumeric(data.phone)}
                            isInvalid={errors.phone}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {data.case === 6 && data.companyKw !== true &&
                <Row className="mt-3">
                    <Col>
                        <fieldset>
                            <Form.Group>
                                <Form.Text as="legend" className="text-dark">
                                    <b>
                                        Um Ihnen bestmöglich helfen zu können,
                                        möchten wir gerne wissen in welcher Situation
                                        Sie sich gerade befinden:
                                    </b>
                                </Form.Text>
                                <Col sm="12">
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                        value="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                        isInvalid={errors.situation}
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Vertragskündigung des Stromanbieters OHNE Folgeangebot"
                                        value="Vertragskündigung des Stromanbieters OHNE Folgeangebot"
                                        isInvalid={errors.situation}
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Höheres Folgeangebot bereits angenommen"
                                        value="Höheres Folgeangebot bereits angenommen"
                                        isInvalid={errors.situation}
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"
                                        value="Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"
                                        isInvalid={errors.situation}
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Börsenabhängiger Flex-/Floattarif"
                                        value="Börsenabhängiger Flex-/Floattarif"
                                        isInvalid={errors.situation}
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Keine der genannten"
                                        value="Keine der genannten"
                                        isInvalid={errors.situation}
                                    />
                                </Col>
                            </Form.Group>
                        </fieldset>
                    </Col>
                </Row>
            }
            {data.case === 6 && data.companyKw !== true && data.situation !== "" &&
                <UploadStage data={data} setData={setData} setStage={setStage} setApiError={setApiError} formErrors={setErrors} />
                
            }
            <div  ref={bottomRef} />
            <Row className="mt-3 text-end" hidden={data.case === 6 && data.companyKw !== true}>
                <Col>
                    <Button variant="warning" onClick={() => btnHandler()}>
                        {data.companyKw ? "Absenden" : "Weiter"}
                    </Button>
                </Col>
            </Row>
        </div>
    )
}
export default FormStage;